const baseURL = process.env.VUE_APP_API_BASE_URL;
if (!baseURL) throw new Error('No API base url specified. Please set up VUE_APP_API_BASE_URL environment variable');

const axiosInstance = require('axios').create({
    baseURL
});

module.exports = axiosInstance;